import React from 'react';
import PartnersFeatureIcon from '../components/PartnersFeatureIcon';
import PartnersSectionHeading from '../components/PartnersSectionHeading';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersFeatures: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <section className="container-chisme py-10 lg:py-16">
      <PartnersSectionHeading
        title={
          <>
            <span className="block">{s.features.titleLine1}</span>
            <span className="block italic text-chisme-primary">{s.features.titleLine2}</span>
          </>
        }
        subtitle={s.features.subtitle}
      />

      <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:gap-6">
        {s.features.items.map((feature) => (
          <div
            key={feature.title}
            className="flex h-full flex-col rounded-[24px] border border-[rgba(74,33,71,0.1)] bg-white p-6"
          >
            <PartnersFeatureIcon id={feature.icon} />
            <h3 className="mt-5 font-instrument text-2xl italic tracking-[-0.01em] text-[#2a0f2a]">
              {feature.title}
            </h3>
            <p className="mt-2 flex-1 font-jakarta text-[14.5px] leading-relaxed text-[#5a3158]">
              {feature.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-6 overflow-hidden rounded-[24px] border border-[rgba(74,33,71,0.1)] bg-white sm:mt-8">
        <div className="border-b border-[rgba(74,33,71,0.1)] px-6 py-6 sm:px-8">
          <div className="flex items-start gap-4">
            <PartnersFeatureIcon id="analytics" />
            <div>
              <h3 className="font-instrument text-2xl italic tracking-[-0.01em] text-[#2a0f2a] sm:text-3xl">
                {s.features.analytics.title}
              </h3>
              <p className="mt-2 font-jakarta text-[14.5px] leading-relaxed text-[#5a3158] sm:text-base">
                {s.features.analytics.subtitle}
              </p>
            </div>
          </div>
        </div>

        <div className="grid gap-px bg-[rgba(74,33,71,0.1)] sm:grid-cols-2 lg:grid-cols-3">
          {s.features.analytics.metrics.map((metric) => (
            <div key={metric.title} className="bg-white p-6 sm:p-7">
              <h4 className="font-instrument text-xl italic text-[#2a0f2a]">{metric.title}</h4>
              <p className="mt-2 font-jakarta text-[14.5px] leading-relaxed text-[#5a3158]">
                {metric.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersFeatures;
